// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_content_delivery_bucket": "diligent-dev-hosting-bucket-dev",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d2tto22mgh0l0f.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-2:aebb289f-2626-47c4-a5f4-c034dc9af74f",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_dYlho8uKQ",
    "aws_user_pools_web_client_id": "2kklbdlbqou78cftiukcuogjsk",
    "oauth": {},
    "predictions": {
        "convert": {
            "translateText": {
                "region": "us-east-1",
                "proxy": false,
                "defaults": {
                    "sourceLanguage": "en",
                    "targetLanguage": "es"
                }
            }
        }
    }
};


export default awsmobile;
